import React, { useEffect, useState, useRef } from 'react';
import { ButtonContainer, Col, Option, Options } from './styles';
import ArrowDown from '../../assets/icons/icon-arrow-down-circle-gray.png';
import { TaglineM, TaglineP } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';

const ButtonList = ({ id, options, ...props }) => {

    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!isOpen) return;
        const onDocClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, [isOpen]);

    const onSelected = (e) => {
        props.onSelected(e)
        setIsOpen(false)
    }

    return(
        <ButtonContainer
            ref={ref}
            width={props.width}
            height={props.height}
            border={props.border}
            isOpen={isOpen}
        >
            <button type="button" className='btn' id={id} onClick={() => setIsOpen(!isOpen)} {...props}
                style={{
                    ...(props.dataAgronomo && { padding: '12px 24px', justifyContent: 'space-between' })
                }}>
                <Col style={{
                    ...(props.dataAgronomo && { alignItems: 'flex-start' })
                }}>
                    {props.value && (
                        <>
                             {props.dataAgronomo ? (
                                <>
                                    {props.legend && (
                                        <TaglineP
                                            color={theme.colors.gray.Cinza_2}
                                            style={{
                                                maxWidth: '148px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >{props.legend}</TaglineP>
                                    )}
                                    <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800} cursor='pointer'>{props.value.label}</TaglineM> 
                                </>
                             ) : (
                                <>
                                    <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800} cursor='pointer'>{props.value.label}</TaglineM> 
                                    {props.legend && (<TaglineP color={theme.colors.gray.Cinza_2}>{props.legend}</TaglineP>)}
                                </>
                             )}
                            
                        </>
                    )}
                </Col>
                <img src={ArrowDown} alt="Ícone de flecha direcionada para baixo" style={{width: props.widthImg || '16px', height: props.heightImg || '16px'}} />
            </button>

            {isOpen && (
                <Options width={props.width} widthOption={props.widthOption} left={props.left} border={props.border} isOpen={isOpen}>
                    {options.map((op, i) => (
                        <Option key={`${op.value}_${i}`} onClick={() => onSelected(op)}>
                            {op.label}
                        </Option>
                    ))}
                </Options>
            )}
        </ButtonContainer>
    )
}

export default ButtonList;